import AbstractComponent from './AbstractComponent';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';

declare var lom_custom: any;

export default class Contact extends AbstractComponent {
  /**
   * The HTML element of the wrapper element of the contact component.
   */
  private $wrapper: HTMLElement;

  /**
   * The HTML elements of the input fields in the form.
   */
  private $fields: NodeListOf<HTMLInputElement | HTMLTextAreaElement>;

  /**
   * The HTML element of the form.
   */
  private $form: HTMLFormElement;

  /**
   * Initializes the contact form.
   */
  public initialize(): void {
    this.$wrapper = document.querySelector('.contact');
    this.$fields = document.querySelectorAll('.contact__form__control');
    this.$form = document.querySelector('.contact__form');

    this.$form.addEventListener('submit', (event) => this.onFormSubmitted(event));
  }

  /**
   * Called when the user submits the contact form.
   *
   * @param event The event arguments
   */
  private onFormSubmitted(event: Event): void {
    event.preventDefault();

    let isFormValid = true;

    // Verify that all the required fields are entered and valid.
    this.$fields.forEach(($field) => {
      if (!$field.required) {
        return;
      }

      $field.classList.remove('is-valid', 'is-invalid');

      let isFieldValid = true;

      switch ($field.type) {
      case 'email':
        isFieldValid = !!$field.value.match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i);
        break;

      default:
        isFieldValid = $field.value.trim().length > 0;
        break;
      }

      if (!isFieldValid) {
        isFormValid = false;

        $field.classList.add('is-invalid');
      } else {
        $field.classList.add('is-valid');
      }
    });

    // Submit the form if everything is correct.
    if (isFormValid) {
      let firstName = this.$form.querySelector('[name="first_name"]') as HTMLInputElement;
      let lastName = this.$form.querySelector('[name="last_name"]') as HTMLInputElement;
      let email = this.$form.querySelector('[name="email"]') as HTMLInputElement;
      let company = this.$form.querySelector('[name="company"]') as HTMLInputElement;
      let message = this.$form.querySelector('[name="message"]') as HTMLInputElement;

      var formData = {
        'name': firstName.value + ' ' + lastName.value,
        'company': company.value,
        'email': email.value,
        'message': message.value,
      }

      window.fetch(lom_custom.base_url + '/api/subscribe/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.text())
        .then((data) => {
          this.$wrapper.classList.add('is-submitted');

          (window as any).dataLayer = (window as any).dataLayer || [];
          (window as any).dataLayer.push({
            'event': 'offer_request',
          });
        })
        .catch((error) => {
          alert('Something went wrong. Please try again later.');
        });
    }
  }
}
